import { IGroupContractModel } from "../../models/group/group-contract.model";
import { IGroupContract } from "../group/group-contract";

export class GroupContractConverter {
  public static toDomain(contract: IGroupContractModel): IGroupContract {
    return {
      contractNumber: contract.contractNumber,
      startDate: contract.startDate,
      startDateCurrentBillingType: contract.startDateCurrentBillingType,
      endDate: contract.endDate,
      type: contract.type,
      active: contract.active,
      takeBackSystemId: contract.takeBackSystemId,
      takeBackSystemName: contract.takeBackSystemName,
      pomAnnouncementPeriod: contract.pomAnnouncementPeriod,
    };
  }

  public static toModel(contract: IGroupContract): IGroupContractModel {
    return {
      contractNumber: contract.contractNumber,
      startDate: contract.startDate,
      startDateCurrentBillingType: contract.startDateCurrentBillingType,
      endDate: contract.endDate,
      type: contract.type,
      active: contract.active,
      takeBackSystemId: contract.takeBackSystemId,
      takeBackSystemName: contract.takeBackSystemName,
      pomAnnouncementPeriod: contract.pomAnnouncementPeriod,
    };
  }
}
